export class DoctorOrder {
    id: number;
    name: string;
    ipId: string;

        constructor() {
    }
}